module.exports = __webpack_public_path__ + "static/media/scout-profile-header.781da6fd.png";